/** Şerit merkezleri yol genişliğine göre normalize (0 = sol kenar, 1 = sağ kenar). */
export function laneCenters(count: number): number[] {
  if (!Number.isInteger(count) || count < 2 || count > 4) throw new Error('Şerit Rallisi 2–4 şerit gerektirir.');
  return Array.from({ length: count }, (_, i) => (i + 0.5) / count);
}
export function nearestLane(x: number, count: number): number {
  return Math.max(0, Math.min(count - 1, Math.floor(x * count)));
}
export function initialLane(count: number) { laneCenters(count); return Math.floor((count - 1) / 2); }
